import * as React from "react";

import ReactTable from "react-table";
import { Column } from "react-table";
import "react-table/react-table.css";

import { Container, Button, InputGroup, InputGroupAddon, Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheckCircle,
    faPencilAlt,
    faTrash
} from "@fortawesome/free-solid-svg-icons";

import "./scenarios.css";
import i18n from "../i18n";

import ScenarioEdit from "./scenario-edit";
import ScenariosCheck from "./scenarios-check";
import { postAsync, getAsync } from "../utils/net";
import { distinctValues } from "../utils/lists";
import ExportDialog from "../designer/exportimport/exportdialog";
import { checkRole } from "../security/security";
import { ToastsStore } from "react-toasts";

// import ImportDialog from "../designer/exportimport/importdialog";

export interface ScenariosDialoghiAttiviTableProps { }
export interface ScenariosDialoghiAttiviTableState {
    scenarios: any[];
    quickfind: string;
    typeValues: any[];
    marketValues: any[];
    loading: boolean;
    selectedItem: any;
    showEdit: boolean;
    showDelete: boolean;
    isNew: boolean;
    showCheck: boolean;
    showExport: boolean;
    // showImport: boolean;
}

export class ScenariosDialoghiAttiviTable extends React.Component<
    ScenariosDialoghiAttiviTableProps,
    ScenariosDialoghiAttiviTableState
> {
    private filterMethod = (filter: any, row: any) =>
        new RegExp(filter.value, "i").test(String(row[filter.id]));

    private columns: Column[] = [
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.Name,
            accessor: "partitionKey"
        },
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.VirtualNode,
            accessor: "virtualNode"
        },
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.Category,
            accessor: "category"
        },
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.Market,
            accessor: "market"
        },
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.Type,
            accessor: "type"
        },
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.Intents,
            accessor: "intents"
        },
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.Entities,
            accessor: "entities"
        },
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.Keywords,
            accessor: "keywords"
        },
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.Channels,
            accessor: "channels"
        },
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.ScenarioDescription,
            accessor: "scenarioDescription"
        },
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.Languages,
            accessor: "languages"
        },
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.UserTypes,
            accessor: "userTypes"
        },
        {
            Header: i18n.ScenariosExportDialoghiAttivi.Table.CheckedOutBy,
            accessor: "checkedOutBy"
        },
        {
            Header: i18n.Global.LastEdit,
            id: "timestamp",
            accessor: (row: any) => row._ts ? new Date(row._ts * 1000) : null,
            Cell: (row: any) => <span>{this.formatDate(row.value)}</span>
        },
        {
            Header: i18n.Global.LastEditBy,
            id: "changedBy",
            accessor: (value: any) => value.changedBy
        },
        {
            Header: "",
            filterable: false,
            show: checkRole("Scenarios.Change"),
            maxWidth: 50,
            Cell: row => (
                <Button
                    size="sm"
                    color="primary"
                    onClick={() => this.onEdit(row.original)}
                >
                    <FontAwesomeIcon icon={faPencilAlt} />
                </Button>
            )
        },
        {
            Header: "",
            filterable: false,
            show: checkRole("Scenarios.Change"),
            maxWidth: 50,
            Cell: row => (
                <Button
                    size="sm"
                    color="danger"
                    onClick={() => this.onDelete(row.original)}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </Button>
            )
        },
    ];
    constructor(props: ScenariosDialoghiAttiviTableProps) {
        super(props);
        this.state = {
            selectedItem: null,
            loading: false,
            showDelete: false,
            showEdit: false,
            isNew: false,
            showCheck: false,
            showExport: false,
            // showImport: false,
            scenarios: [],
            typeValues: [],
            marketValues: [],
            quickfind: "",
        };
    }

    componentWillMount() {
        this.loadScenarios();
    }

    private formatDate(d: Date) {
        if (d) {
            return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} 
      ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
        } else {
            return "";
        }
    }

    render() {
        return (
            <Container fluid={true} className="scenarios-page page">
                <h1 className="page-header">{i18n.ScenariosExportDialoghiAttivi.Title}</h1>
                <p>
                    <Button
                        color="warning"
                        size="sm"
                        onClick={() => this.onCheckConsistency()}
                    >
                        <FontAwesomeIcon icon={faCheckCircle} />
                        &nbsp; {i18n.ScenariosExportDialoghiAttivi.Form.CheckButton}
                    </Button>&nbsp;
                    <Button
                        color="primary"
                        size="sm"
                        onClick={() => this.showExport()}
                    >
                        {i18n.ScenariosExportDialoghiAttivi.Form.ExportButton}
                    </Button>&nbsp;
                    <Button
                        color="primary"
                        size="sm"
                        onClick={() => this.downloadDev()}
                    >
                        {i18n.ScenariosExportDialoghiAttivi.Form.DownloadDevButton}
                    </Button>&nbsp;
                    <Button
                        color="primary"
                        size="sm"
                        onClick={() => this.download()}
                    >
                        {i18n.ScenariosExportDialoghiAttivi.Form.DownloadButton}
                    </Button>&nbsp;
                    {/*WARNING: the import logic is simply commented out, here and in other points of this file */}
                    {/*{checkRole("Scenarios.Change") && (*/}
                    {/*    <Button*/}
                    {/*        color="primary"*/}
                    {/*        size="sm"*/}
                    {/*        onClick={() => this.showImport()}*/}
                    {/*    >*/}
                    {/*        {i18n.ScenariosExportDialoghiAttivi.Form.ImportButton}*/}
                    {/*    </Button>)}*/}
                </p>
                <p>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">🔍</InputGroupAddon>
                        <Input placeholder="quick find" onChange={e => this.onQuickFind(e)} />
                    </InputGroup>
                </p>
                <ReactTable
                    noDataText={this.state.loading ? "Loading" : "No items found"}
                    data={this.list}
                    filterable={true}
                    columns={this.columns}
                    defaultFilterMethod={this.filterMethod}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />
                <ScenarioEdit
                    item={this.state.selectedItem}
                    typeValues={this.state.typeValues}
                    marketValues={this.state.marketValues}
                    isOpen={this.state.showEdit}
                    isNew={this.state.isNew}
                    onCancel={() => this.onCancelEdit()}
                    onSave={model => this.onSave(model)}
                    scenarioList={this.state.scenarios}
                />
                <ExportDialog
                    isOpen={this.state.showExport}
                    onCancel={() => this.onCancelExport()}
                />
                {/*<ImportDialog*/}
                {/*    isOpen={this.state.showImport}*/}
                {/*    onCancel={() => this.onCancelImport()}*/}
                {/*    onImport={(scenarios) => this.onImport(scenarios)}*/}
                {/*/>*/}
                <ScenariosCheck
                    isOpen={this.state.showCheck}
                    scenarios={this.state.scenarios}
                    onClose={() => this.closeCheck()}
                />
            </Container>
        );
    }

    private async loadScenarios() {
        this.setState({ loading: true });
        const reply = await getAsync("/api/designer/getscenarioslist");
        const payload = await reply.json();

        const marketValues = distinctValues(
            payload.map((x: any) => x.market).filter((x: any) => !!x)
        ).map(x => ({ id: x, name: x }));
        const typeValues = distinctValues(
            payload.map((x: any) => x.type).filter((x: any) => !!x)
        ).map(x => ({ id: x, name: x }));

        this.setState({
            scenarios: payload,
            marketValues,
            typeValues,
            loading: false
        });
    }

    private onEdit(item: any) {
        this.setState({ selectedItem: item, showEdit: true });
    }

    private async onDelete(model: any) {
        if (!confirm(i18n.Global.Delete.Confirm)) {
            return;
        }

        try {
            const reply = await postAsync("/api/designer/DeleteScenario", model);
            if (reply.ok) {
                ToastsStore.success(i18n.Scenarios.DeleteOk);
                this.setState({ showEdit: false, isNew: false, selectedItem: null });
                this.loadScenarios();
            } else {
                throw reply;
            }
        } catch (e) {
            // if e is thrown by the postAsync, it is already handled by prompting an alert with the status code error.
            // thus we avoid showing another modal window here
            ToastsStore.error(i18n.Scenarios.DeleteFailure);
        }
    }

    private onCancelEdit() {
        this.setState({ showEdit: false, selectedItem: null });
    }

    private onCancelExport() {
        this.setState({ showExport: false });
    }

    // private onCancelImport() {
    //    this.setState({ showImport: false });
    // }

    // private async onImport(scenarios: any[]) {
    //    try {
    //        const reply = await postAsync("/api/designer/ImportScenarios", scenarios);
    //        if (reply.ok) {
    //            ToastsStore.success(i18n.Scenarios.ImportOk);

    //            this.setState({ showImport: false });
    //            this.loadScenarios();
    //        } else {
    //            throw reply;
    //        }
    //    } catch (e) {
    //      ToastsStore.error(i18n.Scenarios.ImportFailure);
    //    }
    // }

    private async onSave(model: any) {
        try {
            const reply = await postAsync("/api/designer/SaveScenario", model);
            if (reply.ok) {
                this.setState({ showEdit: false, isNew: false, selectedItem: null });
                this.loadScenarios();
            } else {
                throw reply;
            }
        } catch (e) {
            // if e is thrown by the postAsync, it is already handled by prompting an alert with the status code error.
            // thus we avoid showing another modal window here
            ToastsStore.error(i18n.Scenarios.SaveFailure);
        }
    }

    private onCheckConsistency() {
        this.setState({ showCheck: true });
    }

    private showExport() {
        this.setState({ showExport: true });
    }

    // private showImport() {
    //    this.setState({ showImport: true });
    // }

    private closeCheck() {
        this.setState({ showCheck: false });
    }

    private onQuickFind(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            quickfind: e.target.value,
        })
    }

    private get list() {
        return this.state.scenarios
            .filter(this.state.quickfind
                ? item => this.columns.some(col => this.filterMethod({
                    id: col.accessor, value: this.state.quickfind
                }, item))
                : item => true)
    }

    private async downloadDev() {
        try {
            const reply = await getAsync("/api/designer/GetScenariosStagingView");
            const scenarios = await reply.json();
            var jsonObject = JSON.stringify(scenarios);
            const fileName = "dialoghiAttivi_staging.csv";

            this.generateCsv(jsonObject, fileName);
        } catch (e) {
            ToastsStore.error(i18n.Scenarios.DownloadFailure);
        }
    }

    private generateCsv(jsonObject: string, fileName: string) {
        let a = document.createElement("a");
        var csv = "Scenario Name; Virtual Node; Cluster; Market; Type; Intents; Entities; Keywords;"
        csv += "Channels; Scenario Description; User Type\r\n";
        csv += this.convertToCSV(jsonObject);
        var blob = new Blob(["\uFEFF" + csv], {
            type: "text/csv; charset=utf-8"
        });
        a.href = URL.createObjectURL(blob);
        a.download = fileName;
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    private async download() {
        try {
            const reply = await getAsync("/api/designer/GetScenariosProduction");
            const scenarios = await reply.json();
            var jsonObject = JSON.stringify(scenarios);
            const fileName = "dialoghiAttivi_production.csv";

            this.generateCsv(jsonObject, fileName);
        } catch (e) {
            ToastsStore.error(i18n.Scenarios.DownloadFailure);
        }
    }

    private convertToCSV(objArray: any) {
        var array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
        var str = "";
        const columns = ["virtualNode", "category", "market", "type", "intents", "entities",
            "keywords", "channels", "scenariodescription", "userTypes"];

        for (var i = 0; i < array.length; i++) {
            var name = "partitionKey";

            var line = array[i][name] !== null ? this.escapeCsvValue(array[i][name]) : " ";

            for (var col of columns) {
                line += ";";

                // != is checking for both null and "undefined"
                line += array[i][col] != null ? this.escapeCsvValue(array[i][col]) : " ";
            }

            str += line + "\r\n";
        }
        return str;
    }

    private escapeCsvValue(value: string): string {
        if (value.includes(";") || value.includes("\"")) {
            return `"${value.replace(/"/g, "\"\"")}"`;
        }
        return value;
    }
}



// WEBPACK FOOTER //
// ./src/scenarios/scenarios-exportDialoghiAttivi.tsx